import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import { TemplatesAPI } from 'data/templates/api';
import { logger } from 'services';
import { deleteDocumentTemplateTaskAction } from '../../actions';
import { deleteDocumentTemplateTask } from '../../slices';
import { saveDocumentTemplate } from '../_save-template';
function* deleteDocumentTemplateTaskSaga(action) {
    const { payload: { docId, resourceSectionId, taskId } } = action;
    try {
        yield put(deleteDocumentTemplateTask({
            docId,
            resourceSectionId,
            taskId
        }));
        yield TemplatesAPI.wipe(taskId);
        yield saveDocumentTemplate(docId);
    } catch (error) {
        logger.error('deleteDocumentTemplateTask failed', {
            error
        });
        message.error('There was an error removing the task from the document');
    }
}
export const watchDeleteDocumentTemplateTaskSaga = function*() {
    yield takeLatest(deleteDocumentTemplateTaskAction.type, deleteDocumentTemplateTaskSaga);
};
